import { BuilderComponentGroup } from '../types'

export const ButtonsDesignBlocks: BuilderComponentGroup = {
  id: 'buttons',
  title: 'Buttons',
  components: [
    {
      compId: '2-button',
      title: '2 Buttons',
      icon: 'Button2',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
  ],
}
